import { trace } from './lib/trace.js'
trace.getResources('app-gateway')
const ua = window.navigator.userAgent.toLowerCase()
window.$inApp = ua.includes('ztflutter') || ua.includes('ztopenharmony')
import { getZtCoreVersion } from './lib/libs'
import './adapter/index.js'
import 'core-js/stable'
import 'core-js/web/url'
import { initalUserLocale } from './lib/vue-i18n.js'
import './lib/flutter'
import './index.scss'
import './common.css'
import './theme.css'
import init from './lib/init'
import Login from './lib/login'
import { youMongEvent } from './lib/pv-event'
import platform from './platform/index.js'
import getMLogInstance from './lib/mconsole'
import { mount } from './views/home/main.js'
import './lib/useModule.js'
import './lib/service-worker.js'
import './lib/pubsub'

window.$platform = platform()

window.addEventListener('single-spa:before-routing-event', (e) => {
  console.log('single-spa:before-routing-event', e.detail.oldUrl, e.detail.newUrl, e)
  if (e.detail.oldUrl === e.detail.newUrl) {
    e.detail.cancelNavigation()
  }
})

trace.getResources('app-gateway')

const initApp = async () => {
  await init()
  getMLogInstance({ appProject: 'app-gateway' })
  youMongEvent()
  initalUserLocale()
  await Login()
  mount()
}

if (window.flutter_inappwebview) {
  import('./lib/weakNetwork.js').then(({ default: WeakNetworkDetector }) => {
    new WeakNetworkDetector()
  })
  window.flutterReady = () => {}
  if (getZtCoreVersion() < 8) {
    window.__$flutterReadyCallback__(() => {
      window.$flutter.flutterInit()
    })
    initApp()
  } else {
    window.__$flutterReadyCallback__(() => {
      window.$flutter.updateToken()
    })
    initApp()
  }
} else {
  initApp()
}

String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2)
}

if (window.navigator.userAgent.indexOf('Lark/') != -1) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = 'https://lf-scm-cn.feishucdn.com/lark/op/h5-js-sdk-1.5.42.js'
  document.head.appendChild(script)
} else if (window.navigator.userAgent.toLowerCase().indexOf('wxwork') != -1) {
  const script2 = document.createElement('script')
  script2.async = true
  script2.type = 'text/javascript'
  script2.src = 'https://static.service.z-trip.cn/resources/lib/wxwork-jweixin-1.0.0.js'
  document.head.appendChild(script2)

  const script3 = document.createElement('script')
  script3.async = true
  script3.type = 'text/javascript'
  script3.src = 'https://wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.3.3.js'
  document.head.appendChild(script3)
}

function LoadBaiduMapScript(callback) {
  const BMap_URL = 'https://api.map.baidu.com/api?v=3.0&ak=YthGcNXzpz9NmKiT56VOHk98ofeGGt7k&s=1&callback=onBMapCallback'
  //如果已加载直接返回
  if (typeof BMap !== 'undefined') {
    callback({
      code: 0
    })
    return
  } //百度地图异步加载回调处理
  window.onBMapCallback = function () {
    console.log('百度地图脚本初始化成功...')
    callback({
      code: 0
    })
  } //插入script脚本

  let scriptNode = document.createElement('script')
  scriptNode.onerror = function (res) {
    console.error(' script.onerror ', res)
    callback({
      code: -1
    })
  }
  scriptNode.setAttribute('type', 'text/javascript')
  scriptNode.setAttribute('src', BMap_URL)
  document.body.appendChild(scriptNode)
}

if (window.zzzconfig && window.zzzconfig.isBlockDomain && window.zzzconfig.isBlockDomain() == false) {
  LoadBaiduMapScript(function (retData) {
    if (retData.code != 0) {
      console.error('百度地图加载失败!')
    }
  })
}

function LoadBaiduMapGLScript(callback) {
  const AK = 'YthGcNXzpz9NmKiT56VOHk98ofeGGt7k'
  const BMap_URL = 'https://api.map.baidu.com/api?v=1.0&type=webgl&ak=' + AK + '&callback=onBMapGLCallback'
  if (typeof BMapGL !== 'undefined') {
    callback({
      code: 0
    })
    return
  } //百度地图异步加载回调处理
  window.onBMapGLCallback = function () {
    console.log('百度地图GL脚本初始化成功...')
    callback({
      code: 0
    })
  } //插入script脚本
  let scriptNode = document.createElement('script')
  scriptNode.crossorigin = 'anonymous'
  scriptNode.onerror = function (res) {
    console.error(' script.onerror ', res)
    callback({
      code: -1
    })
  }
  scriptNode.setAttribute('type', 'text/javascript')
  scriptNode.setAttribute('src', BMap_URL)
  document.body.appendChild(scriptNode)
}
window.LoadBaiduMapGLScript = LoadBaiduMapGLScript

$tool.loadCSS('https://static.service.z-trip.cn/app/ztrip/css/index.min.css')

import('./lib/daike.js')
import('./lib/useDebugger')
